function Footer() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        style={{
          height: "80px",
          background: "black",
          width: "100%",
          marginBottom: "20px",
        }}
      ></div>
      <p>Build with React and StyleComponent.</p>
    </div>
  );
}

export default Footer;
